<template>
    <div id="main" style="z-index: 100000">
        <div class="dashHeader">
            <h2>Dashboard</h2> 
            <button id="minimize" v-on:click="minimize" style="top:0px; right:0px; position:absolute; background: var(--color-background); border-radius: 10px;border:none;"><span class="material-icons-sharp" style="color: var(--color-dark);">remove</span></button>   
        <button id="maximize" v-on:click="maximize" style="top:0px; right:25px; position:absolute; background: var(--color-background); border-radius: 10px;border:none;"><span class="material-icons-sharp" style="color: var(--color-dark);">add</span></button>           
        </div>
        <div v-if="isHidden==false" class="insights">
            <div class="sales">
                <div class="middle">
                    <div class="left">
                        <img src="../../assets/img/aeronave_voo.png">
                        <h3>Aeronaves em voo</h3>
                        <h1>{{ aeronaveEmMovimento }}</h1>
                    </div>
                </div>
            </div>
            <!-----------------END OF SALES------------------>

            <div class="sales">
                <div class="middle">
                    <div class="left">
                        <img src="../../assets/img/aeronave_parada.png">
                        <h3>Aeronaves paradas</h3>
                        <h1>{{ aeronaveParada }}</h1>
                    </div>
                </div>
            </div>
            <!-----------------END OF EXPENSES------------------>

            <div class="sales">
                <div class="middle">
                    <div class="left">
                        <img src="../../assets/img/servidor_sem_resposta.png">
                        <h3 id="alertaServidoresTravados">Servidores travados</h3>
                        <h1 id="alertaServidores">{{ servidoresTravados }}</h1>
                    </div>
                </div>
            </div>
            <!-----------------END OF INCOMES------------------>
            <div class="sales">
                <div class="middle">
                    <div class="left">
                        <img src="../../assets/img/posicoes_atrasadas.png">
                        <h3 id="posicoesTravadas">Posições travadas</h3>
                        <h1 id="posicoesTravadasLabel">{{ posicaoTravada }}</h1>
                    </div>
                </div>
            </div>
            <!-----------------END OF SALES------------------>

            <div class="sales">
                <div class="middle">
                    <div class="left">
                        <img src="../../assets/img/posicoes_na_fila.png">
                        <h3 id="trechoTravado">Trechos travados</h3>
                        <h1 id="trechoTravadoLabel">{{ trechoTravado }}</h1>
                    </div>
                </div>
            </div>
            <!-----------------END OF EXPENSES------------------>

            <div class="sales">
                <div class="middle">
                    <div class="left">
                        <img src="../../assets/img/falha_api.png">
                        <h3 id="alertaServicosApi">APIs travadas</h3>
                        <h1 id="alertaServicos">{{ servicosTravados }}</h1>
                    </div>
                </div>
            </div>
            <!-----------------END OF INCOMES------------------>
        </div>
        <!-----------------END OF INSIGHTS------------------>
    </div>
</template>

<script>

export default {

    props: ['aeronaveEmMovimento', 'aeronaveParada', 'posicaoTravada', 'trechoTravado', 'servidoresTravados', 'servicosTravados'],

    data() {
        return {
            isHidden:false
        };
    },

    methods: {

        minimize(){
            this.isHidden = true
        },

        maximize(){
            this.isHidden = false
        }
    },

    updated() {

        if (this.servidoresTravados > 0)
        {
            document.getElementById("alertaServidoresTravados").style.color = "red"
            document.getElementById("alertaServidores").style.color = "red"
        }

        else
        {
            document.getElementById("alertaServidoresTravados").style.color = "#363949";
            document.getElementById("alertaServidores").style.color = "#363949";
        }

        if (this.posicaoTravada > 0)
        {
            document.getElementById("posicoesTravadas").style.color = "red"
            document.getElementById("posicoesTravadasLabel").style.color = "red"
        }

        else
        {
            document.getElementById("posicoesTravadas").style.color = "#363949";
            document.getElementById("posicoesTravadasLabel").style.color = "#363949";
        }

        if (this.trechoTravado > 0)
        {
            document.getElementById("trechoTravado").style.color = "red"
            document.getElementById("trechoTravadoLabel").style.color = "red"
        }

        else
        {
            document.getElementById("trechoTravado").style.color = "#363949";
            document.getElementById("trechoTravadoLabel").style.color = "#363949";
        }

        if (this.servicosTravados > 0)
        {
            document.getElementById("alertaServicosApi").style.color = "red"
            document.getElementById("alertaServicos").style.color = "red"
        }

        else
        {
            document.getElementById("alertaServicosApi").style.color = "#363949";
            document.getElementById("alertaServicos").style.color = "#363949";
        }

    },
}
</script>


<style lang="scss" scoped>

#main {
    position: absolute;
    z-index: 9;
    width: 450px;
    font-family: poppins, sans-serif;
    bottom: 5px;
    right: 5px;
    background: var(--color-background);
    opacity: 0.8;
    box-shadow: 0 0 40px -10px rgba(0, 0, 0, .8);
    border-radius: 10px;
}
.dashHeader{
    opacity: 0.8;
    border-radius: 10px;
    margin-bottom: 0px;
}

.dashHeader h2{
    margin-bottom: 0.8rem;
    font-family: poppins, sans-serif;
    font-size: 20px;
    color: var(--color-primary);
    text-align: center;
    padding: 8px;
}

h1 {
    font-weight: 800;
    font-size: 15px;
    color:#363949;
}

h3 {
    font-weight: 800;
    color: #363949;
    margin: 0.2rem 0 0.6rem;
    font-size: 16px;
}

img {
    height: 24px;
    width: 24px;
    margin-top: -10px;
}

#main .insights {
    gap: 1rem;
    padding: 10px;
    border-radius: 10px;
    background: var(--color-background);

    transition: all 300ms ease;
    height: max-content;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: dense;
}

#main .insights>div {
    background-color: rgba(200, 200, 200, .9);
    border: 1px solid #f1f1f1;
    padding: 10px;
    text-align: center;
    border-radius: var(--card-border-radius);
    transition: all 300ms ease;
    height: 100px;
    box-shadow: 0 0 40px -10px rgba(0, 0, 0, .4);
}

.sales {
    grid-row: span 3;
}

#main .insights>div:hover {
    box-shadow: none;
}

#main .insights:hover {
    box-shadow: none;
}

// #main .insights>div .middle {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
// }
</style>





// WEBPACK FOOTER //
// src/views/monitoramento/dashboard.vue